import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { NgIf } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatTooltip } from '@angular/material/tooltip'

@Component({
  selector: 'table-list-consultant',
  imports: [
    MatButton,
    MatTableModule,
    MatIcon,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    MatProgressSpinner,
    MatTooltip,
  ],
  templateUrl: './table-list-consultant.component.html',
  styleUrl: './table-list-consultant.component.scss',
})
export class TableListConsultantComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Input() loading = false
  @Input() listClient = false

  @Output() selectItem = new EventEmitter<any>()
  @Output() removeItemEvent = new EventEmitter<any>()
  @Output() addItemEvent = new EventEmitter<any>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  selectItemEvent(item: any): void {
    this.selectItem.emit(item)
  }

  removeItem(item: any): void {
    this.removeItemEvent.emit(item)
  }

  addItem(item: any): void {
    this.addItemEvent.emit(item)
  }
}
